import { useIntl } from 'react-intl-next';

import { useDefaultCatch } from '@atlassian/eoc-catch';
import { errorToastProps } from '@atlassian/eoc-common';
import { useFlags } from '@atlassian/eoc-global-context';
import { useResource } from '@atlassian/eoc-rrr-helpers';

import commonMessages from '../../common/messages';
import { type UiPreferences } from '../../common/types';

import { updateUiPreferencesEndpoint } from './endpoints';
import { uiPreferencesResource } from './resources';

const defaultUiPreferences: UiPreferences = {
	defaultSavedSearchId: '',
	alertListTime: {
		range: 'all',
	},
	lastSearchedQuery: '',
	alertListType: 'cozy',
	alertListSortField: 'insertedAt',
	canSeeAllAlerts: false,
	visibilityFilterToggle: false,
	uvShowAlertGroups: false,
};

export const useUiPreferencesService = () => {
	const { showFlag } = useFlags();
	const { formatMessage } = useIntl();
	const defaultCatch = useDefaultCatch();

	const { data, update, loading } = useResource(uiPreferencesResource);

	const updateUiPreferences = (data: Partial<UiPreferences>) => {
		update((state) => ({ ...state, ...data }));
		return updateUiPreferencesEndpoint(data).catch(
			defaultCatch({
				id: 'useUiPreferencesService-update',
				httpErrorHandler: (err) => {
					showFlag({
						...errorToastProps(),
						description: err.message,
						title: formatMessage(commonMessages.errorTitle),
					});
				},
			}),
		);
	};

	return {
		data: data ?? defaultUiPreferences,
		isLoading: loading,
		update: updateUiPreferences,
	};
};
